import ResponsiveListContainer from '../../ResponsiveListContainer';
import FooterComponent from './FooterComponent';
import mockCustomerProducts from './mocks';
import CategoryChipsComponent from '../mobile-delivery-summary/CategoryChipsComponent';
import PricesListTopComponent from './TopComponent';
import HeaderSideComponent from './HeaderSIdeComponent';
import PricesListSingleRowComponent from './SingleRow';
import { TopChipsActionComponent } from '../customer-products/TopChipsActionsComponent';
import React, { useCallback, useState } from 'react';
import {useSearchParams} from "react-router-dom";
import {HeadCell} from "../../../../../types";
import Customer from "../../../../../types/customer";
import {useDispatch, useSelector} from "react-redux";
import {getCustomers, selectActiveCustomers} from "../../../../../store/customers/customersSlice";
import {useQueryClient} from "react-query";
import {CUSTOMER_PRODUCTS, useGetCustomerProductsPrices} from "../../../../../hooks/customer/products.hooks";
import {dateObjectToString} from "../../../../../fromKotlin/nkutils";
import { updateAllPrice } from 'api/customer/products_prices.api';
import JSDB from 'fromKotlin/nk';
import IItem from "../../../../../types/product_delivery";
import {Alert, CircularProgress, Dialog} from '@mui/material';
import Snackbar from "@mui/material/Snackbar";
import DialogContent from "@mui/material/DialogContent";

const MobilePricesList = () => {
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const id = searchParams.get('id'); // Extract customer ID from query params
    const [totalPrice, setTotalPrice] = useState(0);
    const [priceChanges, setPriceChanges] = useState([]);
    const [isAnySelected, setIsAnySelected] = useState(false);
    const [onlytAvailable, setOnlyAvailable] = React.useState( localStorage.getItem('onlyAvailable') === 'true');
    const customers: Customer[] = useSelector(selectActiveCustomers);
    const [date, setDate] = React.useState(new Date());
    const [loadingDialog, setLoadingDialog] = useState(false);
    const [successSnackbar, setSuccessSnackbar] = useState(false);
    const [checked, setChecked] = React.useState(false);
    React.useEffect(() => {
        if (!customers || customers.length == 0)
            dispatch(getCustomers());
    }, [dispatch]);
    const cache = useQueryClient();
    const { data: products, isLoading, refetch } = useGetCustomerProductsPrices(id, dateObjectToString(date), checked, true,true);
    const [tempData,setTempData] = React.useState([]);

    React.useEffect(() => {
        if (products) {
            setTempData(products);
        }
    },[products]);
    React.useEffect(() => {
        if (!isLoading) {
            cache.removeQueries(CUSTOMER_PRODUCTS);

            refetch();
        }

    }, [date, checked]);
    const saveDataCallback = React.useCallback(async (priceChanges) => {
        try {
            setLoadingDialog(true); // Show loading dialog
            const toDateTemp = undefined;

            const x = await updateAllPrice(
                priceChanges.map(d => {
                    const client = JSDB().getClient(Number(id)).first;
                    return {
                        id: Number(id),
                        product_id: d.id,
                        price: d.totalPrice,
                        discount: d.discount,
                        master: d.master && d.master !== -1 ? d.master : -1
                    };
                }),
                dateObjectToString(date),
                toDateTemp ? dateObjectToString(toDateTemp) : undefined,
                false,
                undefined,
                undefined
            );

            refetch();
            setPriceChanges([]);
            setSuccessSnackbar(true); // Show success
            return true;
        } catch (e) {
            console.error(e);
            return false;
        } finally {
            setLoadingDialog(false); // Close loading dialog
        }
    }, [date]);

    const MemoizedSingleRowComponent = useCallback(
        () => (
            <PricesListSingleRowComponent setData={setTempData} data={tempData} setIsAnySelected={setIsAnySelected} setPriceChanges={setPriceChanges} />
        ),
        [tempData,setTempData, setTotalPrice, setIsAnySelected,setPriceChanges]
    );

    return (

        <>
            <ResponsiveListContainer
                topChips={PricesListTopComponent}
                lowerChips={CategoryChipsComponent}
                FooterComponent={() => <FooterComponent priceChanges={priceChanges}  save={saveDataCallback}/>}
                mainContent={tempData}
                SingleRowComponent={(props) => (
                    <PricesListSingleRowComponent
                        {...props}
                        setData={setTempData}
                        setIsAnySelected={setIsAnySelected}
                        setPriceChanges={setPriceChanges}
                    />
                )}
                HeaderSideComponent={HeaderSideComponent}
                singleRowGap={0}
                outsideHooks={{ setDate, setChecked, onlytAvailable, setOnlyAvailable,date,checked,setPriceChanges,saveDataCallback,priceChanges }}
                // topChipsActions={isAnySelected ? TopChipsActionComponent : null}
            />
            {/* 🔄 Loading Dialog */}
            <Dialog open={loadingDialog} disableEscapeKeyDown>
                <DialogContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 200, minHeight: 100 }}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>

            {/* ✅ Success Snackbar */}
            <Snackbar
                open={successSnackbar}
                autoHideDuration={3000}
                onClose={() => setSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSuccessSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    המחירים נשמרו בהצלחה
                </Alert>
            </Snackbar>
        </>
    );
};

export default MobilePricesList;
